import * as tslib_1 from "tslib";
import React, { useContext, useEffect, useMemo } from 'react';
import classnames from 'classnames';
import { GlinteractionContext } from '../Glinteraction';
import s from './ActionBarIcon.scss';
var ActionBarIcon = function (_a) {
    var Icon = _a.icon, isActive = _a.isActive, isGlinting = _a.isGlinting, children = _a.children, onAnimationEndFromProps = _a.onAnimationEnd;
    var onGlintDone = useContext(GlinteractionContext).onGlintDone;
    var onAnimationEnd = useMemo(function () { return (isGlinting && !isActive ? onGlintDone : onAnimationEndFromProps); }, [isActive, isGlinting, onAnimationEndFromProps, onGlintDone]);
    useEffect(function () {
        // we cannot glint if active, so call callback immediately
        if (isActive && isGlinting) {
            onGlintDone();
        }
    }, [isActive, isGlinting, onGlintDone]);
    var iconProps = {
        className: classnames(s['icon'], isActive && s['active'], !isActive && isGlinting && s['glint']),
        customSizable: true,
        disableDefaultColors: true,
        onAnimationEnd: onAnimationEnd,
    };
    if (children) {
        return React.createElement(React.Fragment, null, children(iconProps));
    }
    if (Icon) {
        return React.createElement(Icon, tslib_1.__assign({}, iconProps));
    }
    return null;
};
ActionBarIcon.displayName = 'ActionBarIcon';
export default ActionBarIcon;
//# sourceMappingURL=ActionBarIcon.js.map